import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

export default function AdminRoute({ children }) {
  const { isAuthenticated, roleId } = useContext(AuthContext);
  const location = useLocation();

  if (!isAuthenticated) {
    const redirectTo = `/sign-in?redirect=${encodeURIComponent(
      location.pathname + location.search
    )}`;
    return <Navigate to={redirectTo} replace />;
  }

  if (roleId !== 3) {
    return <Navigate to="/" replace />;
  }

  return children;
}
